module.exports = __webpack_public_path__ + "img/www.yelp.com.df71a978.png";